import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
	container: {
		height: 30,
		width: 100,
		borderRadius: 5,
		padding: "0 .4rem",
	},
	spanContainer: {
		color: "#fff",
		fontWeight: 500,
		lineHeight: "1.2em",
		textAlign: "center",
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "-webkit-box",
		"-webkit-line-clamp": "2",
		"-webkit-box-orient": "vertical",
	},
});
